export const GA_MEASUREMENT_ID = "G-3DG539KC3B";
export const GOOGLE_MAPS_API_KEY=process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

export const WHATSAPP_SUPPORT_NUMBER = '919266391960';
export const CREATOR_APP_URL = 'https://app.influns.com';